export default {
  //A
  "All rights reserved": "All rights reserved",
  Admin: "Admin",
  Accepted: "Accepted",
  Arrived: "Arrived",
  "About the panel": "About the panel",
  "Adapted to your needs": "Adapted to your needs",
  "Adjust credit": "Adjust credit",
  "Update credit": "Update credit",
  "Credit limit adjustment": "Credit limit adjustment",
  "Credit limit adjustment history": "Credit limit adjustment history",
  "Track changes made to the credit limits of your associated panels.":
    "Track changes made to the credit limits of your associated panels.",
  "Panel ID": "Panel ID",
  "Associated panel": "Associated panel",
  "Date and time": "Date and time",
  "Previous limit": "Previous limit",
  "New limit": "New limit",
  "Adjustment type": "Adjustment type",
  "Adjustment source": "Adjustment source",
  Increase: "Increase",
  Decrease: "Decrease",
  "No changes": "No changes",
  "Sales executive": "Sales executive",
  "Panel administrator": "Panel administrator",
  "api partner": "api partner",
  Panel: "Panel",
  "Modify credit limit": "Modify credit limit",
  "Assigned amount": "Assigned amount",
  "Available to distribute": "Available",
  "Credit limit updated successfully": "Credit limit updated successfully",
  "Error fetching available credit limit": "Error fetching available credit limit",
  "Error updating credit limit": "Error updating credit limit",
  "Error fetching credit distribution": "Error fetching credit distribution",
  NEW_CREDIT_LIMIT_EXCEESS_MASTERS:
    "The new credit limit exceeds the master credit limit",
  CORPORATE_NOT_FOUND: "Panel not found",
  "Arrange trips for your clients": "Arrange trips for your clients",
  Additionally: "Additionally",
  "Also driver's availability near the origin point of the trip":
    "Also driver's availability near the origin point of the trip",
  ACTION: "ACTION",
  Apply: "Apply",
  "Available balance": "Balance",
  AMOUNT: "AMOUNT",
  "AGREGADO/RESTADO": "ADD/CUT",
  "ADD/CUT": "ADD/CUT",
  "Add to payroll": "Add to payroll",
  Active: "Active",
  Activo: "Active",
  Suspendido: "Suspended",
  "Activate overdraft": "Activate overdraft",
  "Activate user": "Activate user",
  Approved: "Approved",
  All: "All",
  Assignations: "Assignations",
  "Additionally, our monitoring team is always at willingness to deal with any incident":
    "Additionally, our monitoring team is always at willingness to deal with any incident",
  "Also driver's availability near the origin point of the parcel":
    "Also driver's availability near the origin point of the parcel",
  Accept: "Accept",
  Approve: "Approve",
  and: "and",
  automated_payments: "Automated payments",
  automated_zelle: "Automated zelle",
  automated_pago_movil: "Automated pago móvil",
  // API
  api_credentials_generate_token: "Generate token",
  api_credentials_is_allowed_corporate_api_partner:
    "Global access to corporate api partners allowed",
  api_credentials_is_corporate_api_partner:
    "Singular access to corporate api partners allowed",
  api_credentials_is_allowed_corporate_shipment_api:
    "Singlular access to corporate api partners shipment api",
  api_credentials: "Credentials",
  api_credentials_tooltip:
    "In this view you can review, and edit edit your API credentials",
  api_credentials_active_api: "Permissions and access active in the API",
  api_credentials_active_api_tooltip:
    "In this section you can review permissions and access active in the API",
  api_permissions_table_header: "Permission",
  api_active_table_header: "Active",
  api_credentials_is_allowed_corporate_api_partner_tooltip:
    "This permission indicates if Ridery has allowed access to its API to its API Partners",
  api_credentials_is_corporate_api_partner_tooltip:
    "This permission indicates if Ridery has allowed access to the Corporate Panel to its API Partners API",
  api_credentials_is_allowed_corporate_shipment_api_tooltip:
    "This permission indicates whether the Corporate Panel has particular access to the Ridery API for API Partners for Shipments",
  api_credentials_token: "Token",
  api_credentials_token_tooltip:
    "In this section you can review and generate a token used to access the API for Ridery Api Partners",
  api_credentials_token_label: "Token for auth in API",
  api_credentials_webhook_title: "Webhook",
  api_credentials_webhook_title_tooltip:
    "In this section, you can set up a Webhook to receive notifications about status changes of trips/shipments you have made as an API Partner",
  api_credentials_send_webhook: "Send Webhook",
  api_credentials_send_webhook_deactivate: "Deactivate Webhook",
  api_documentation: "Documentation",
  api_documentation_tooltip:
    "In this view you can review the documentation for API Partners",
  //B
  Basic: "Basic",
  Balance: "Balance",
  CorporateInvoices: "Invoices",
  CreditDistribution: "Credit distribution",
  IslrRetention: "Withholdings",
  "Back to the panel": "Back to the panel",
  By: "By",
  "Book you work trips": "Book you work trips",
  "Book a demonstration with our team": "Book a demonstration with our team",
  "Balance top-up request": "Balance top-up request",
  "By admin": "By admin",
  BALANCE: "BALANCE",
  "Billing Info": "Billing information",
  "Billing info text": "Complete this information to continue receiving invoices for each service. It's quick and secure!",
  "Billing name": "Legal name",
  "Billing name placeholder": "Enter your legal name",
  "Billing email": "Billing email",
  "Billing email placeholder": "Enter your email address",
  "Billing rif letter": "Type",
  "Billing rif no": "Document number",
  "Billing rif placeholder": "Enter your document",
  "Billing address": "Billing address",
  "Billing address placeholder": "Enter your billing address",
  "Billing save": "Save information",
  "Billing success": "Billing information saved successfully",
  "Billing failure": "Error saving billing information",
  "By clicking here you can refresh the map":
    "By clicking here you can refresh the map",
  "By clicking you can refresh the nearby providers in the map":
    "By clicking you can refresh the nearby providers in the map",
  Brand: "Brand",
  "BALANCE INICIAL": "INITIAL BALANCE",
  "BALANCE FINAL": "FINAL BALANCE",
  "BALANCE INICIAL (CORPORATIVO)": "INITIAL BALANCE",
  "BALANCE FINAL (CORPORATIVO)": "FINAL BALANCE",
  "BALANCE INICIAL (USUARIO)": "INITIAL BALANCE",
  "BALANCE FINAL (USUARIO)": "FINAL BALANCE",
  bulk: {
    unitary: "Unitary",
    bulk: "Bulk",
  },
  //C
  "Create a new Trip": "Create a new Trip",
  Corporate: "Corporate",
  clear: "limpiar",
  Completed: "Completed",
  "Partially completed": "Partially completed",
  Cancelled: "Cancelled",
  Coming: "Coming",
  "Cancelled by user": "Cancelled by user",
  "Corporate Panel": "Corporate Panel",
  "Corporate Panels": "Corporate panels",
  "Corporate Panels Totals": "Total corporate panels",
  Contact: "Contact",
  "Control your spending": "Control you spending",
  Contactverb: "Contact",
  "Contact form": "Contact form",
  "Can I book a trip or make reservations for another person?":
    "Can I book a trip or make reservations for another person that's not in my panel?",
  "Create trip": "Create trip",
  "Current and scheduled trips": "Current and scheduled trips",
  CONDUCTOR: "PROVIDER",
  COST: "COST",
  COSTO: "COST",
  "Cancel trip": "Cancel trip",
  Cancel: "Cancel",
  "Charge of this trip": "Charge of this trip",
  Card: "Card",
  "CORREO ELECTRÓNICO": "EMAIL",
  "Contact corporativo@ridery.app requesting the invoice of the recharge previously made, or failing that, to the fill out the payment form select ''YES'' in the field of invoice.":
    "Write an email to corporativo@ridery.app requesting the invoice for the recharge previously made, otherwise, when filling out the payment form, select ''YES'' in the invoice field.",
  "Create a new Parcel": "Create a new Parcel",
  "Current and scheduled parcel": "Current and scheduled parcels",
  Clear: "Clear",
  copy_trip_details: "Copy trip details link",
  copy_trip_details_success: "Trip details link copied successfully",
  copy_parcel_details: "Copy parcel details link",
  copy_parcel_details_success: "Parcel details link copied successfully",
  CorporatePanels: "Corporate panels",
  corporate_master_assign: "Master panel top up",
  CorporatePanel: "Corporate panel",
  contact_us: "Contact us",
  "Credit distribution": "Credit distribution",
  //D
  Dashboards: "Dashboards",
  "Destination address": "Destination address",
  "Date and Time": "Date and Time",
  "Dirección de origen": "Origin address",
  "Dirección de destino": "Destination address",
  DISTANCIA: "DISTANCE",
  DURACIÓN: "DURATION",
  "DATE AND TIME": "DATE AND TIME",
  "DIRECCIÓN DE ORIGEN": "ORIGIN ADDRESS",
  "DIRECCIÓN DE DESTINO": "DESTINATION ADDRESS",
  "DESTINATION ADDRESS": "DESTINATION ADDRESS",
  "Do you want to cancel the trip?": "Do you want to cancel the trip",
  "Date range": "Date range",
  "Deactivate overdraft": "Deactivate overdraft",
  "Date issued": "Date issued",
  "Date paid": "Date paid",
  Discount: "Discount",
  Details: "Details",
  "Driver's app certification": "Driver's app certification",
  Delete: "Delete",
  "Driver Waiting": "Driver Waiting",
  "Driver Info": "Driver information",
  //E
  Email: "Email",
  "Enter your email and we'll send you instructions to reset your password":
    "Enter your email and we'll send you instructions to reset your password",
  "Email sent": "Email sent",
  "Enter your new password": "Enter your new password",
  "Error creating trip": "Error creating trip",
  Export: "Export",
  EMAIL: "EMAIL",
  "Eliminate user": "Eliminate user",
  "Efficiency in the execution of your budget.":
    "Guarantee efficiency in the execution of your budget.",
  "Excess": "Available balance",
  "Excess tooltip": "Balances in bolívares are not indexed.",
  "Excess auto": "This balance will be automatically applied to your next invoice",
  //F
  "Forgot Password?": "Forgot Password?",
  OTHERS: "OTHER SERVICES",
  FINANCIAL: "FINANCIAL",
  FAQ: "FAQ",
  FAQ2: "FAQ",
  "Fecha y hora": "Date and time",
  "FECHA Y HORA": "DATE AND TIME",
  "Find your workers inside Ridery's app to add them to your payroll":
    "Find your workers inside Ridery's app to add them to your payroll",
  "For your safety": "For your safety",
  "For your comfort": "For your comfort",
  "For increased efficiency": "For increased efficiency",
  fullName: "Full name",
  //G
  GoBack: "Go back",
  "Get quote": "Get quote",
  "Get quick quote": "Get quick quote",
  "Go to page": "Go to page",
  "Good Morning!": "Good Morning!",
  "Good Afternoon!": "Good Afternoon!",
  "Good Evening!": "Good Evening!",
  //H
  History: "History",
  "History ": "History ",
  "How is a trip's fare calculated?": "How is a trip's fare calculated?",
  "How do I pay for my business trips?": "How do I pay for my business trips?",
  "How does Ridery take care of the safety of its passengers?":
    "How does Ridery take care of the safety of its passengers?",
  "How do I receive invoices for my company's trips?":
    "How do I receive invoices for my company's trips?",
  "How can I control my payroll expenses?":
    "How can I control my payroll expenses?",
  "How to request the invoice prior to recharging?":
    "How to request the invoice prior to recharging?",
  hide_user_panel: "Hide user panel",
  show_user_panel: "Show user panel",
  //I
  Inmediate: "Inmediate",
  "Invalid credentials": "Invalid credentials",
  "In this view you can visualize the trips in course on the map":
    "In this view you can visualize the trips in course on the map",
  "In this map view you can visualize the waypoints origin and destination":
    "In this map view you can visualize the waypoints origin and destination",
  "In this form you can create a new trip for now or scheduled":
    "In this form you can create a new trip for now or scheduled",
  "If you need to adjust coordinates for a trip you can use the source and destination pointers for that purpose":
    "If you need to adjust coordinates for a trip you can use the source and destination pointers for that purpose",
  "In this table you can consult all current and scheduled trips associated with your corporate panel":
    "In this table you can consult all current and scheduled trips associated with your corporate panel",
  "ID VIAJE": "TRIP ID",
  "ID USUARIO": "USER ID",
  Inactive: "Inactive",
  Invoice: "Service note",
  "Invoice to": "Service note to",
  "in a": "in a",
  "Ideal balance between cost control and self-management.":
    "Get thei deal balance between cost control and self-management.",
  "In this view you can visualize the parcels in course on the map":
    "In this view you can visualize the parcels in course on the map",
  "In this form you can create a new parcel for now or scheduled":
    "In this form you can create a new parcel for now or scheduled",
  "If you need to adjust coordinates for a parcel you can use the source and destination pointers for that purpose":
    "If you need to adjust coordinates for a parcel you can use the source and destination pointers for that purpose",
  "in corporate panels": "in corporate panels",
  //Q
  "quick, confortable and secure way": "quick, confortable and secure way",
  //L
  Login: "Login",
  Logout: "Logout",
  Landing: "Welcome",
  "Last name": "Last name",
  "Limit amount": "Amount limit",
  Link: "Link",
  "Live monitoring, accompaniment and assignment 24 hours a day of the day, 7 days a week with a response time from 3 to 7 minutes.":
    "live monitoring, accompaniment and assignment 24 hours a day of the day, 7 days a week with a response time from 3 to 7 minutes.",
  "Lo sentimos, Ridery no presta servicio en esa dirección de origen":
    "We are sorry, Ridery does not have service in that origin address",
  //M
  "More information": "More information",
  "more panels": "more panels",
  "Monitor your trips": "Monitor your trips",
  MONTO: "AMOUNT",
  "Manage your trips": "Manage your trips",
  Model: "Model",
  "Movements": "Movements",
  "Movement trip": "Trip charge",
  "Movement admin add": "Admin added balance",
  "Movement admin cut": "Admin deducted balance",
  Multistop: "Multistops",
  multistop_quoted: "Quoted multistops",
  multistop_quoted_tooltip:
    "In this view you can review the quoted multisops, approve or deny. Every multitop expires 15 min before the set date",
  multi_stop_new: "New multistop quote",
  multistop_delete_modal: "Would you like to delete the quote ?",
  multistop_total_stop: "Stop total",
  multistop_time_stop: "Total time",
  multistop_distance_stop: "Total distance",
  multistop_new_map_tooltip:
    "In this map view you can review the multistop stops",
  multiStopNew: "New multistop",
  multistop_add: "Add",
  multistop_add_tooltip: "In this form you can stops to a multistop trip",
  multistop_stop: "Stop",
  multistop_origin: "Origin",
  multistop_full_1: "You've reached the maximum of allowed stops",
  multistop_full_2: "You can review the stop list and summary",
  multistop_list: "Stops list",
  multistop_list_tooltip:
    "In this table you can review the stops list of a multistop trip",
  multistop_total_resume: "Multistop summary",
  multistop_total_resume_tooltip:
    "In this view you can review the summary of the multistop",
  multistop_total_quote: "Quote multistop",
  multi_stop: "Multistop",
  multistop_show_quote_title: "Quote detail (Multistop)",
  multistop_show_quote_title_tooltip:
    "In this view you can see the details of multistop quote",
  multistop_approve: "Approve multistop quote",
  multistop_map_view: "Trip map (Multistop)",
  multistop_quote_success: "Multistop quote success",
  MultistopShow: "Multistop trip detail",
  manual_top_up_request: "Manual top ups",
  manual_top_up_pending_table: "Manual top ups waiting for validation",
  manual_top_up_pending_table_tooltip:
    "In this view you can consult your manual top ups waiting for validation",
  manual_payments_pending_see_details: "See details",
  //N
  "New Trip": "New Trip",
  "Not corporate": "Not corporate",
  Name: "Name",
  "Nombre y apellido": "Full name",
  "No driver": "No driver",
  NAME: "NAME",
  NOMBRE: "NAME",
  Note: "Note",
  "Not approved": "Not approved",
  "NON FISCAL": "NON FISCAL",
  "Monitoreo (Viajes) Teléfono": "Monitor (Trips) Phone",
  "Monitoreo (Viajes) Correo electrónico": "Monitor (Trips) Email",
  "must accept the request in Ridery's user app":
    "must approve the request in Ridery's user app",
  NOTA: "NOTE",
  "New Parcel": "New Parcel",
  no: "No",
  //O
  "Origin address": "Origin address",
  "Our clients": "Our clients",
  "Our sales team is capacitated to show you a demo with the whole potential of the panel":
    "Get to know in depth the benefits we have for your company, collaborators and clients.",
  "Obligatory field": "Obligatory field",
  Operator: "Operator",
  Overdraft: "Overdraft",
  "ORIGIN ADDRESS": "ORIGIN ADDRESS",
  "ORIGEN DE TRANSACCIÓN": "TRANSACTION ORIGIN",
  OVERDRAFT: "OVERDRAFT",
  "Optimize your time": "Optimize your time",
  "Our drivers must pass a selection process of 4 stages:":
    "We ensure a robust driver and vehicle certification process, and additionally, our monitoring team is always available to attend to any need that may arise.",
  "Our operators are 24 hours for you! Communicate for the following means for any incident or inconvenience presented:":
    "You can contact 24/7 with our operators through two service channels: Whatsapp +58 (412) 604-29-80 or the email viaje@ridery.app",
  "Our trips are calculated based on a fixed rate per fleet selected being able to have various surcharges (time of day, traffic conditions, etc) if applicable.":
    "We take as a basis a fixed rate per selected fleet, on which variations may apply depending on the schedule, traffic, weather, among other factors.",
  //P
  "Panel users": "Employees",
  "Panel balance": "Payroll balance",
  "Panel status": "Panel status",
  "Panel limit": "Credit limit",
  "Panel available": "Available credit",
  "Panel consumed": "Consumed credit",
  "Panel active": "Active invoices",
  "Panel overdue": "Overdue invoices",
  "Panel outstanding": "Outstanding amount",
  "Panel action": "Action",
  "Panels associated": "Associated panels",
  "Panels active": "Active panels",
  "Panels suspended": "Suspended panels",
  "Panels inactive": "Inactive panels",
  "Panels suspended tooltip": "Panels with restricted service due to overdue invoices or reaching the credit limit.",
  "Panels inactive tooltip": "Panels that are deactivated and cannot operate.",
  payment_accounts_title: "Confirm your payments faster",
  payment_accounts_subtitle:
    "Add the bank accounts you usually pay us from. We'll recognize and credit your transfers more quickly, with no wait to confirm each payment.",
  payment_accounts_security_notice:
    "We only need the account number. We do not ask for PINs, balances, or account holder details.",
  payment_accounts_field_label: "Account",
  payment_accounts_add: "+ Add account",
  payment_accounts_submit: "Save",
  payment_accounts_no_national_transfer: "I do not pay with national transfer",
  payment_accounts_success: "Accounts saved successfully",
  payment_accounts_error: "Could not save the accounts",
  payment_accounts_invalid: "Enter at least one 20-digit account",
  "Please sign-in to your account and manage your trips":
    "Please sign-in to your account and manage your trips",
  Password: "Password",
  Profile: "Profile",
  "Please check your email": "Please check your email",
  PasswordConfirm: "Password confirm",
  "Password reset": "Password reset",
  Provider: "Provider",
  "Provider detail error": "Error loading provider details",
  Payroll: "Payroll",
  PROVIDER: "PROVIDER",
  PHONE: "PHONE",
  Print: "Print",
  "Psychotechnical evaluation": "Integral psychotechnical evaluation",
  "Psycho-technical evaluation, vehicle certification (aesthetics and mechanical), up-to-date legal documentation and final exam of app approval":
    "Psycho-technical evaluation, vehicle certification (aesthetics and mechanical), up-to-date legal documentation and final exam of app approval",
  "Plate number": "Plate number",
  provider_name: "Provider name",
  Phone: "Phone",
  "Phone no": "Phone number",
  PARCELS: "PARCELS",
  "Parcel Type": "Parcel Type",
  "Parcel now": "Instant",
  "Parcel responsible user": "Parcel responsible user",
  "Parcel history": "Parcels history",
  "PARCEL ID": "ID DE ENVÍO",
  "ID DE ENVÍO": "PARCEL ID",
  parcel_receives_tooltip: "This person will be contacted by the driver",
  parcel_receiver: "Who receives the parcel?",
  parcel_textarea: "Additional parcel details",
  parcel_textarea_error:
    "Additional details must be 150 characters long or less",
  parcel_create: "Create parcel",
  parcel_cancel: "Cancel parcel",
  parcel_cancel_modal: "Do you want to cancel the parcel?",
  parcel_details: "Parcel details",
  parcel_details_table: "Who receives the parcel",
  parcelHistory: "Parcel history",
  parcel_table_running_tooltip:
    "In this table you can consult all current and scheduled parcels associated with your corporate panel",
  Parcels: "Parcels",
  ParceltooltipHistoryUser:
    "In this view you can see the user's parcel history with the corporate panel",
  parcel_more_info: "Policies",
  ParcelGuide: "Parcel policies",
  parcel_created: "Parcel created successfully",
  parcel_package_size: "Package size",
  parcel_package_mass: "Package weight",
  parcel_package_examples: "You can send these types of packages:",
  parcel_view_map_title: "Parcel map",
  parcel_view_map_completed_tooltip:
    "In this view you can see the approximate route of a completed parcel between point of origin and destination",
  parcel_view_map_completed_tooltip2:
    "In this view you can visualize the map status of a current parcel (if applicable) and the points of origin and destination",
  parcel_cancelled: "Parcel cancelled successfully",
  parcel_cancelled_error: "Error cancelling parcel",
  parcel_multistop_add_tooltip:
    "In this form you can add stops to a multipstop parcel",
  parcel_multistop_list_tooltip:
    "In this table you can review the list of stops of a multistop parcel",
  person_is_contact: "This person will be contacted by the driver",
  pago_movil_automatizado_tooltip:
    "Reload your corporate balance with our new pago móvil automatizado system",
  pago_movil_new: "New",
  ParcelMultistop: "Parcel multistops",
  parcelMultiStopNew: "New multistops parcel",
  parcelMultiStopShow: "Parcel multistops detail",
  parcel_continue: "Continue",
  parcel_i_send: "Sends",
  parcel_i_receive: "Receives",
  parcel_textarea_1_send: "Instructions at the pickup",
  parcel_textarea_1_receive: "Instructions at the destination",
  parcel_data_person_send: "Data of the person receiving",
  parcel_data_person_receive: "Data of the person sending",
  parcel_user_full_name: "Name and last name",
  parcel_textarea_2_send: "Instructions at the destination",
  parcel_textarea_2_receive: "Instructions at the pickup",
  parcel_textarea_package: "Package description",
  parcel_package: "Package",
  parcel_package_image: "Package image",
  parcel_upload_image: "Upload image",
  parcel_prohibited_items: "Prohibited items",
  parcel_prohibited_items_shipments: "in our shipments",
  parcel_prohibited_fireamrs: "Firearms",
  parcel_prohibited_substances: "Illicit substances",
  parcel_prohibited_cash: "Cash",
  parcel_prohibited_waste: "Toxic waste",
  parcel_prohibited_lingots: "Bullion",
  parcel_prohibited_fireworks: "Fireworks",
  parcel_prohibited_insecticides: "Insecticides",
  parcel_shipment_summary: "Shipment summary",
  parcel_quote_origin: "Origin",
  parcel_not_defined_remittent: "Not defined",
  parcel_image_error_size: "The image must be below 5mb",
  parcel_image_error_required: "Image is required",
  parcel_quote_sender: "Peson who sends",
  parcel_quote_sender_phone: "Telephone",
  parcel_quote_instructions_on_origin: "Instructions at the origin",
  parcel_quote_destination: "Destination",
  parcel_quote_receiver: "Person who receives",
  parcel_quote_recoiver_phone: "Telephone",
  parcel_quote_instructions_on_destination: "Instructions at the destination",
  parcel_quote_package_photo: "Package photo",
  parcel_quote_package_description: "Package description",
  parcel_parcel: "Parcel",
  //R
  REQUESTS: "REQUESTS",
  "Running trips": "Running trips",
  "Realtime map": "Map",
  "Reset your password": "Reset your password",
  "Results per page": "Results per page",
  "REMAINING BALANCE": "REMAINING BALANCE",
  "Ridery's Corporate team": "Ridery's Corporate team",
  "Ridery Contact": "Ridery Contact",
  "Ridery Corporate": "Ridery Corporate",
  "Request a ride in less than 10 minutes.":
    "Request a ride in less than 10 minutes.",
  "Refresh table": "Refresh table",
  "Refresh map": "Refresh map",
  "Running parcels": "Running parcels",
  //Q
  "Quick quote": "Quick quote",
  //S
  Scheduled: "Scheduled",
  Started: "Started",
  Send: "Send",
  "Service type": "Service type",
  Search: "Search",
  "Search by...": "Search by...",
  STATUS: "STATUS",
  "SALDO RESTANTE": "REMAINING BALANCE",
  Status: "Status",
  SALDO: "BALANCE",
  SOBREGIRO: "OVERDRAFT",
  "Simultaneously move your collaborators or clients.":
    "Simultaneously move your collaborators or clients.",
  "Schedule a meeting with our team": "Schedule a meeting with us",
  Sobredemanda: "Surge",
  Service: "Service",
  SERVICIO: "SERVICE",
  special_trip: "Special trip",
  //T
  "Trip Type": "Trip Type",
  Telephone: "Telephone",
  "Travel now": "Travel now",
  "Tipo de viaje": "Trip type",
  "Tipo de usuario": "User type",
  "Tipo de servicio": "Service type",
  "Trip created successfully": "Trip created successfully",
  "TRIP ID": "TRIP ID",
  "Trip cancelled successfully": "Trip cancelled successfully",
  "Trip history": "Trip history",
  tooltipHistory:
    "In this view you can check the trip history, filter and export .xls",
  tooltipBalance:
    "In this view you can see the different operations on your balance",
  "Transaction origin": "Transaction origin",
  "TRANSACTION ORIGIN": "TRANSACTION ORIGIN",
  tooltipUsers1:
    "In this view you can check your payroll and make basic administration actions such as:",
  tooltipCorporatePanels1:
    "In this view you can check your corporate panels and make basic administration actions such as:",
  tooltipUsers2: "Add users, manage overdrafts, add balance, remove users",
  tooltipCorporatePanels2: "Add balance or view corporate panels",
  "Total master": "Master total credit limit",
  "Total master tooltip": "Credit limit defined with your account executive. To modify it, please contact them.",
  TELÉFONO: "PHONE",
  "Thank you for choosing us": "Thank you for choosing us",
  Tax: "Tax",
  "This receipt does not represent a fiscal invoice":
    "This service note does not represent a fiscal invoice",
  "Trip map": "Trip map",
  tooltipTripMap:
    "In this view you can see the approximate route of a completed trip between point of origin and destination",
  tooltipTripMap2:
    "In this view you can visualize the map status of a current trip (if applicable) and the points of origin and destination",
  "Trip ID": "Trip ID",
  "Trip ID must be an integer": "Trip ID must be an integer",
  "Provider name": "Driver's name",
  Trips: "Trips",
  tooltipUserAssign:
    "In this view, you can review the movements that affect the user's balance.",
  "Through our toolset": "Through our toolset",
  "To enter our fleet drivers must pass a 4-stage selection process":
    "to enter our Ridery fleet a driver must pass an exteneous 4-stage selection process",
  "Total users": "Total users",
  "Trip in couse": "Trip in couse",
  tooltipHistoryUser:
    "In this view you can see the user's trip history with the corporate panel",
  "This input is autocomplete": "This input is autocomplete",
  tooltipHistoryParcel:
    "In this view you can review the parcel's history of the panel",
  TripInfo: "Información",
  trip: {
    trip_resume: "Trip summary",
  },
  topUps: "Top Ups",
  tooltipTopUps: "Here you can select a payment method to do a balance top up",
  //U
  "used": "Used",
  "Use toggle": "Use {balance} for the trip",
  "Use user": "user credit",
  "Use corporate": "panel credit",
  "Use tooltip off":
    "When creating a trip for the corporate user {user}, the cost will be debited from their {uBalance_text} ({uBalance_value}), or from their {overdraft}.",
  "Use tooltip on":
    "The cost of this trip will be deducted from the corporate account credit ({credit}). The user's balance will not be affected.",
  USERS: "USERS",
  User: "User",
  Users: "Users",
  unassigned: "Unassigned",
  unique_id: "ID Viaje",
  user_first_name: "User name",
  "User type": "User type",
  "User name": "User name",
  USER: "USER",
  USUARIO: "USER",
  "User amount": "User amount",
  "USER ID": "USER ID",
  "Up-to-date legal documentation": "Up-to-date legal documentation",
  "User does not have sufficient balance or there isn't enough overdraft":
    "User does not have sufficient balance or there isn't enough overdraft",
  user_wallet: "User balance",
  userWallet: "user balance",
  user_found_db_ridery: "User found in Ridery's database",
  user_found_db_ridery_filling: "Automatically filling inputs",
  //V
  ViewMap: "View map",
  "View user": "View user",
  "View provider": "Ver provider",
  "View map": "View map",
  "View invoice": "View invoice",
  "Vehicle certification (aesthetics and mechanics)":
    "Aesthetic and mechanical review",
  Vehicle: "Vehicle",
  variable_tariffs: "Our tariffs may vary",
  "View corporate panel": "View corporate panel",
  "Panel view": "View panel",
  //W
  "Welcome!": "Welcome!",
  Waiting: "Waiting",
  "We've sent an email to": "We've sent an email to",
  "Welcome again": "Welcome again",
  "Waiting for approval": "Waiting for approval",
  "We are the app that modernizes your business mobility":
    "We are the app that modernizes your business mobility",
  "We have an extensive fleet of vehicles, ranging from the most economical to passenger buses in the whole national territory.":
    "we have an extensive fleet of vehicles, ranging from the most economical to passenger buses in the whole national territory.",
  "We have the following means for you to contact us. Our team will gladly assist you.":
    "Our team is willing to assist any requirement. We mainly have two channels to answer your queries or doubts.",
  "What should I do if I file an incident with my app?":
    "What should I do if I file an incident with my app?",
  //Y
  "You can log back in": "You can log back in",
  "You can create trips for your corporate users or for third-party users":
    "You can create trips for your corporate users or for third-party users",
  Yes: "Yes",
  "You've selected an invalid hour, previous to current time. Please select a different hour":
    "You've selected an invalid hour, previous to current time. Please select a different hour",
  "Yes! When requesting a trip through the Corporate Panel, select ''Non-Corporate User'', fill in the fields, you proceed to request the trip and that's it, your rider will arrive right away.":
    "Yes! When requesting a trip through the Corporate Panel, select ''Non-Corporate User'', fill in the fields, you proceed to request the trip and that's it, your rider will arrive right away.",
  "You can also make quick quotes": "You can also make quick quotes",
  Year: "Year",
  "you may search corporate users by:": "You may search corporate users by:",
  "You can create parcel for your corporate users or for third-party users":
    "You can create parcel for your corporate users or for third-party users",
  yes: "Yes",

  // headers
  "LAST STOP": "LAST STOP",
  "ÚLTIMA PARADA": "LAST STOP",

  STOPS: "STOPS",
  PARADAS: "STOPS",

  SERVICE: "SERVICE",

  STOP: "STOP",
  PARADA: "STOP",

  "STOP COST": "STOP COST",
  "COSTO DE PARADA": "STOP COST",

  FEE: "FEE",
  RECARGO: "FEE",

  "TOTAL STOP": "TOTAL STOP",
  "TOTAL PARADA": "TOTAL STOP",

  "STOP QUANTITY": "STOP QUANTITY",
  "CANTIDAD PARADAS": "STOP QUANTITY",

  "ESTIMATED TIME": "ESTIMATED TIME",
  "TIEMPO ESTIMADO": "ESTIMATED TIME",

  "ESTIMATED DISTANCE": "ESTIMATED DISTANCE",
  "DISTANCIA ESTIMADA": "ESTIMATED DISTANCE",

  "MULSTISTOP COST": "MULSTISTOP COST",
  "COSTO MULTIPARADA": "MULSTISTOP COST",

  Add: "Add",
  Remove: "Remove",
  "Promo Code": "Promo Code",
  "Add Promo Code": "Add Promo Code",
  "The promo code has expired or is invalid":
    "The promo code you entered is not valid",
  "Promo code applied successfully": "Promo code applied successfully",
  "Error getting estimated fare with promo code":
    "Error getting estimated fare with promo code",

  "trip description": "Trip description",
  "TRIP DESCRIPTION": "TRIP DESCRIPTION",

  "Add Description": "Add Description",
  "Add trip description": "Add trip description",
  Completado: "Completed",
  DESCRIPTION: "DESCRIPTION",

  "Exporting parcels": "Exporting parcels",
  "Exporting trips": "Exporting trips",
  "You can download the export file": "You can download the export file",
  "The export file has": "The export file has",
  expired: "expired",
  "Procesando páginas para archivo Excel": "Processing pages for Excel file",
  "Procesando página": "Processing page",
  of: "of",
  "Sorry, there was an error": "Sorry, there was an error",
  Close: "Close",
  Download: "Download",

  "Download PDF": "Download PDF",
  "Service Note": "Service Note",
  "Download Quote": "Download Quote",
  "Service Quote to": "Service Quote to",
  "Service Quote": "Service Quote",
  SURGE: "SURGE",
  TOTAL: "TOTAL",
  "Note: This quote represents a referential value of the trip. This is only a quote, if you want to schedule the trip contact your agent.":
    "Note: This quote represents a referential value of the trip. This is only a quote, if you want to schedule the trip contact your agent.",
  "the value of the trip is subject to change":
    "the value of the trip is subject to change",
  "PARADA FINAL": "FINAL STOP",

  "Exporting payments": "Exporting payments",
  "Pago móvil automatizado": "Automated pago móvil",
  "FACTURA PERSONALIZADA": "CUSTOM INVOICE",
  MONEDA: "CURRENCY",
  TIPO: "TYPE",
  "FECHA ENVIADO": "DATE SENT",
  "FECHA DE RECARGA": "RECHARGE DATE",

  Total: "Total",

  DESCRIPCIÓN: "DESCRIPTION",
  "Cancel Reason": "Cancel Reason",
  "Select one of the following reasons to cancel this trip":
    "Select one of the following reasons to cancel this trip",
  Confirm: "Confirm",

  "Enter current password": "Enter current password",
  "Enter new password": "Enter new password",
  "Confirm new password": "Confirm new password",
  "Incorrect password": "Incorrect password",
  "Change password": "Change password",
  "Your password has been saved successfully":
    "Your password has been saved successfully",
  "Passwords do not match": "Passwords do not match",
  Continue: "Continue",

  "Passwords must match": "Passwords must match",
  "Recover password": "Recover password",
  "To recover your password, enter your email":
    "To recover your password, enter your email",
  GOBACK: "GO BACK",
  "with instructions":
    "with instructions to reset your password. Check your inbox, including the spam folder",
  "Check your email": "Check your email",
  "Set the new password and its confirmation":
    "Set the new password and its confirmation",
  PasswordNewConfirm: "Confirm new password",
  "New Password": "New Password",
  ResetPassword: "Reset Password",
  "We're sorry!": "We're sorry!",
  "The link has expired. Request a new link to reset your password":
    "The link has expired. Request a new link to reset your password",
  "Back to the start": "Back to the start",
  "Error resetting password": "Error resetting password",
  "An error occurred, please try again later":
    "An error occurred, please try again later",
  "The email is not valid": "The email is not valid",
  "Charge of this parcel": "Charge of this parcel",
  NOTE: "NOTE",
  ForgotPassword: "Forgot Password",
  "Select payment method": "Select payment method",
  Available: "Available",
  "Amount is required": "Amount is required",
  "Amount must be greater than 0": "Amount must be greater than 0",
  "Amount to add": "Amount to add",
  "Amount to pay": "Amount to pay",
  "Make the payment to": "Make the payment to",
  Bank: "Bank",
  "Bank copied!": "Bank copied!",
  "RIF copied!": "RIF copied!",
  "Phone number": "Phone number",
  "Phone number copied!": "Phone number copied!",
  "Enter the details of the pago móvil made":
    "Enter the details of the pago móvil made",
  Operador: "Operator",
  "Payment date": "Payment date",
  "Last 4 reference digits": "Last 4 reference digits",
  Back: "Back",
  "Text copied": "Text copied",
  "not found in Ridery's database": "Transfer not found in Ridery's database",
  "You can review the data of": "Review the data entered and try again or request assistance to your sales executive",
  "and try again or request assistance": "and try again or request assistance",
  "Request Assistance": "Request Assistance",
  "Review data": "Review data",
  "Top up pending!": "We're processing your payment!",
  "Your manual top up has been sent to Ridery's database":
    "Your manual payment has been successfully submitted.",
  "Invoice status update banner emphasis": "Your invoices will be updated",
  "Invoice status update banner detail": " once your payment is validated.",
  "Payment result partial banner emphasis":
    "The amount received is less than the total amount.",
  "Payment result partial banner detail":
    " Some invoices will remain with an outstanding balance or in partial payment status.",
  "Payment result success banner emphasis": "Excellent!",
  "Payment result success banner detail":
    " Your invoices were paid and their status was updated automatically.",
  "Top up successful!": "Top up successful!",
  Added: "Added",
  "to your corporate balance of a pago móvil of Bs":
    "to your corporate balance of a pago móvil of Bs",
  "to your corporate balance from a payment":
    "to your corporate balance from a payment",
  "Corporate balance": "Corporate balance",
  "Account holder": "Account holder",
  "Account holder copied!": "Account holder copied!",
  "Email copied!": "Email copied!",
  "Memo number": "Memo number",
  "Memo number copied": "Memo number copied!",
  "Enter the details of the zelle made": "Enter the details of the zelle made",
  "Enter your payment date": "Enter your payment date",
  "Amount sent": "Amount sent",
  "The amount sent cannot exceed {max}.":
    "The amount sent cannot exceed {max}.",
  "Zelle owner": "Zelle owner",
  "The zelle owner is the person or entity that made the payment":
    "The zelle owner is the person or entity that made the payment",
  "Do you want a custom invoice?": "Do you want a custom invoice?",
  "Is this top up related to a proform?":
    "Is this top up related to a proform?",
  "Proforma number": "Proforma number",
  "Make your payment using the following coordinates and instructions":
    "Make your payment using the following coordinates and instructions",
  Reference: "Reference",
  "Send your payment receipt and related information to process the transaction":
    "Send your payment receipt and related information to process the transaction",
  "email to send invoice": "email to send invoice",
  No: "No",
  "payment receipt": "payment receipt",
  "Payment receipt": "Payment receipt",
  Recharge: "Recharge",
  "BALANCE HISTORY": "BALANCE HISTORY",
  "MANUAL TOP UPS": "MANUAL TOP UPS",
  "You've selected an invalid time. Please select a time that is at least 15 minutes from now.":
    "You've selected an invalid time. Please select a time that is at least 15 minutes from now.",
  "You've selected an invalid time. Please create a new quote is at least 10 minutes from now.":
    "You've selected an invalid time. Please create a new quote is at least 10 minutes from now.",

  "The link has expired. Request a new link to reset enter in assist mode":
    "The link has expired. Request a new link to reset enter in assist mode",
  "Welcome to": "Welcome to",
  "Usa tus credenciales del admin y accede a la cuenta":
    "Use your admin credentials and access the panel",
  "Assist Mode": "Assist Mode",

  "Exporting payroll": "Exporting payroll",
  "Esperando aprobación": "Waiting for approval",
  Inactivo: "Inactive",
  "How to start?": "How to start?",
  "Contact us": "Contact us",
  "Start today": "Start today",
  Benefits: "Benefits",
  Solutions: "Solutions",
  "All Ridery services, adapted to": "All Ridery services, adapted to",
  "your business": "your business",
  "The ecosystem of mobility, shipping and logistics in a single place":
    "The ecosystem of mobility, shipping and logistics in a single place",
  "Mobility and shipping": "Mobility and shipping",
  "Request or schedule comfortable and safe transfers with verified drivers.":
    "Request or schedule comfortable and safe transfers with verified drivers.",
  "Shipping and logistics": "Shipping and logistics",
  "Manage and track your business deliveries in an automated way.":
    "Manage and track your business deliveries in an automated way.",
  "Benefits for your collaborators": "Benefits for your collaborators",
  "Show appreciation to your employees and customers with credits and coupons.":
    "Show appreciation to your employees and customers with credits and coupons.",
  "Logistics and heavy cargo": "Logistics and heavy cargo",
  "Request services for moves, distribution routes and more.":
    "Request services for moves, distribution routes and more.",

  Welcome: "Welcome",
  Updated: "Updated",
  "See more": "See more",
  Shipments: "Shipments",
  "Trips this month": "Trips this month",
  "Shipments this month": "Shipments this month",
  Collaborators: "Collaborators",
  "View trip": "View trip",
  "View shipment": "View shipment",
  Forbidden: "Forbidden",
  Actives: "Active",
  "Create shipment": "Create shipment",
  Summary: "Summary",
  "In progress": "In progress",
  "No trips yet": "No trips yet",
  "No shipments yet": "No shipments yet",
  HELP: "HELP",
  Support: "Support",

  tooltipCredit:
    "Corporate advances are an advance in your balance so you can continue making trips in the panel, contact your executive for more information",
  Credits: "Advances",
  "Billed amount": "Billed amount",
  "PAY ADVANCE": "PAY ADVANCE",
  "PAY DEBT": "PAY DEBT",
  day: "day",
  days: "days",
  Missing: "Missing",
  Expired: "Expired",
  Expires: "Expires",

  "Pago exitoso!": "Successful payment!",
  "Was credited": "Was paid",
  "to your credit of a pago móvil of Bs":
    "to your advance of a pago móvil of Bs",
  "Credit balance": "Advance balance",
  "Exporting corporate credits": "Exporting corporate advances",
  "This is the amount advanced to the account for the advance":
    "This is the amount advanced to the account for the advance",
  ID: "ID",
  "AMOUNT ADVANCED": "AMOUNT ADVANCED",
  "AMOUNT PAID": "AMOUNT PAID",
  "EXPIRATION DATE": "EXPIRATION DATE",
  "Credit Detail": "Advance Detail",
  "Advance data": "Advance data",
  "Approval date": "Approval date",
  "Expiration date": "Expiration date",
  "Paid amount": "Paid amount",
  "Amount added": "Amount added",
  "Credit data": "Advance data",
  "Credit movements": "Advance movements",
  "Email to send invoice": "Email to send invoice",
  Contáctanos: "Contact us",

  "Full name": "Full name",
  "Company name or business name": "Company name or business name",
  "Error verifying reCAPTCHA": "Error verifying reCAPTCHA",
  "Position in company": "Position in company",
  Industry: "Industry",
  "Other (specify)": "Other (specify)",
  "Specify industry": "Specify industry",
  "Estimated number of employees": "Estimated number of employees",
  City: "City",
  "Specify city": "Specify city",
  "How can we help you?": "How can we help you?",
  "Specify how we can help you": "Specify how we can help you",
  "How did you hear about us?": "How did you hear about us?",
  "Specify how you found us?": "Specify how you found us?",
  Comments: "Comments",
  "Complete the form and a representative from our team will contact you.":
    "Complete the form and a representative from our team will contact you.",
  "Error sending form": "Error sending form",
  "validation.required": "This field is required",
  "validation.min": "The field must have at least {length} characters",
  "validation.numeric": "Only numbers are allowed",
  "validation.phone": "The phone number must have exactly 10 digits",
  "validation.max": "The field must have at most {length} characters",

  // Industries
  Distribuidores: "Distributors",
  Banca: "Banking",
  "Servicios Profesionales": "Professional Services",
  Transporte: "Transportation",
  Salud: "Healthcare",
  Tecnología: "Technology",
  "Fundación / ONG": "Foundation / NGO",
  Marketing: "Marketing",
  Servicios: "Services",
  Seguros: "Insurance",
  Otros: "Other (specify)",
  "Consumo masivo": "Mass consumption",
  Retail: "Retail",

  // Employees
  "1 - 10": "1 - 10",
  "11 - 50": "11 - 50",
  "51 - 200": "51 - 200",
  "201 - 500": "201 - 500",
  "500+": "500+",

  // Cities
  "Altos Mirandinos": "Altos Mirandinos",
  "Barcelona / Puerto La Cruz / Lechería":
    "Barcelona / Puerto La Cruz / Lechería",
  Barquisimeto: "Barquisimeto",
  Caracas: "Caracas",
  "Guarenas-Guatire": "Guarenas-Guatire",
  Maracaibo: "Maracaibo",
  Maracay: "Maracay",
  "Puerto Ordaz": "Puerto Ordaz",
  Valencia: "Valencia",

  // How can we help you
  "Business mobility: simplifies the transfers and shipments of your team in the city.":
    "Business mobility: simplifies the transfers and shipments of your team in the city.",
  "Article delivery: perform automated shipments and on demand for your clients.":
    "Article delivery: perform automated shipments and on demand for your clients.",
  "Events and expenses: provides balance for travel or meals to your collaborators.":
    "Events and expenses: provides balance for travel or meals to your collaborators.",
  "Employee benefits: pays KMs or buys gift cards for your employees.":
    "Employee benefits: pays KMs or buys gift cards for your employees.",
  "Employee transportation: schedules buses for recurring routes.":
    "Employee transportation: schedules buses for recurring routes.",
  "Group travel: rent group transport vehicles for specific events or transfers.":
    "Group travel: rent group transport vehicles for specific events or transfers.",
  "Smart logistics: manages freight, moves, transport and cargo logistics for your business.":
    "Smart logistics: manages freight, moves, transport and cargo logistics for your business.",
  "Support: personalized 24/7 support to manage your trips, shipments and logistics.":
    "Support: personalized 24/7 support to manage your trips, shipments and logistics.",

  // How did you find us
  Event: "Event",
  Advertising: "Advertising",
  "Referred by a known": "Referred by a known",
  "Social media": "Social media",

  "Additional comments": "Additional comments",

  // Contact page
  "¿Tienes preguntas sobre": "Do you have questions about",
  "Ridery 360": "Ridery 360",
  "Completa el formulario y en breve te contactaremos para aclarar tus dudas.":
    "Complete the form and we will contact you shortly to clarify your questions.",

  // Contact Confirmation page
  "¡Gracias por contactarnos!": "Thank you for contacting us!",
  "Nos comunicaremos contigo lo antes posible para atenderte y conocer las necesidades de tu negocio.":
    "We will contact you as soon as possible to attend to you and know the needs of your business.",
  "Volver al inicio": "Back to the start",
  corporate_credit_added: "Advance added",
  corporate_credit_reverted: "Advance reverted",
  corporate_credit_payment: "Advance payment",
  "Movimientos del adelanto": "Advance movements",
  Refresh: "Refresh",
  "See payroll": "See payroll",
  "Associated panels": "Associated panels",
  NoDataAssociatedPanels: "There are no active associated panels",
  "Associated Panel": "Associated Panels",
  amountRecharge: "Amount recharged",
  "Make shipments and transfers with certified vehicles.":
    "Make shipments and transfers with certified vehicles.",
  "Drivers with verified access and secure processes":
    "Drivers with verified access and secure processes",
  "Automate your business deliveries with API integration.":
    "Automate your business deliveries with API integration.",
  "Promote your brand while you move": "Promote your brand while you move",
  "Operational efficiency for your business":
    "Operational efficiency for your business",
  "The integral solution that moves your business.":
    "The integral solution that moves your business.",
  "Discover how companies maximize the panel to optimize their processes.":
    "Discover how companies maximize the panel to optimize their processes.",
  Services: "Services",

  // Landing Page Translations
  "Transform your company's mobility": "Transform your company's mobility",
  "Move your company quickly, comfortably and safely, at the best price in the market.":
    "Move your company quickly, comfortably and safely, at the best price in the market.",
  Our: "Our",
  "corporate panel": "corporate panel",
  "Manage your company's transfers at any time":
    "Manage your company's transfers at any time",
  "Create or schedule trips instantly, monitor your business shipments and check the status of your budget using your business account":
    "Create or schedule trips instantly, monitor your business shipments and check the status of your budget using your business account",
  "Manage your budget in real time": "Manage your budget in real time",
  "Create invoices and account statements in seconds to keep track of your mobility expenses effortlessly":
    "Create invoices and account statements in seconds to keep track of your mobility expenses effortlessly",
  "Affiliate your entire company with a few clicks":
    "Affiliate your entire company with a few clicks",
  "Add specific people or your entire organization with bulk payroll upload and assign available balances in a personalized way":
    "Add specific people or your entire organization with bulk payroll upload and assign available balances in a personalized way",
  "Make trips or shipments with multiple destinations":
    "Make trips or shipments with multiple destinations",
  "Move your team to different points in the city or send important packages to multiple destinations in the same trip with more economical rates.":
    "Move your team to different points in the city or send important packages to multiple destinations in the same trip with more economical rates.",
  "What is Ridery 360?": "What is Ridery 360?",
  "It is a comprehensive solution for companies that combines mobility, logistics, advertising and services oriented to the welfare of employees, centralized in a platform designed to facilitate management, optimize operations and enhance the growth of businesses of any size at the national level.":
    "It is a comprehensive solution for companies that combines mobility, logistics, advertising and services oriented to the welfare of employees, centralized in a platform designed to facilitate management, optimize operations and enhance the growth of businesses of any size at the national level.",
  "How to start using Ridery 360?": "How to start using Ridery 360?",
  "Once your 360 panel is activated, you can start using Ridery 360 by recharging balance through a prepaid modality. That balance is used to cover trips, shipments or other services within the platform. There are no mandatory subscriptions or individual charges.":
    "Once your 360 panel is activated, you can start using Ridery 360 by recharging balance through a prepaid modality. That balance is used to cover trips, shipments or other services within the platform. There are no mandatory subscriptions or individual charges.",
  "What level of security does Ridery 360 offer for corporate transfers and shipments?":
    "What level of security does Ridery 360 offer for corporate transfers and shipments?",
  "Ridery has 100% certified drivers and vehicles. From the panel, companies can monitor each transfer in real time, guaranteeing traceability, security and operational control.":
    "Ridery has 100% certified drivers and vehicles. From the panel, companies can monitor each transfer in real time, guaranteeing traceability, security and operational control.",
  "What other services are part of Ridery 360?":
    "What other services are part of Ridery 360?",
  "In addition to trips and shipments, Ridery 360 includes access to services such as advertising in our spaces, API integration for automated deliveries, and synergies with allied companies such as Flety (transport and cargo logistics) and Busi (group mobility). Everything is managed from the same panel, providing a unified experience within the ecosystem.":
    "In addition to trips and shipments, Ridery 360 includes access to services such as advertising in our spaces, API integration for automated deliveries, and synergies with allied companies such as Flety (transport and cargo logistics) and Busi (group mobility). Everything is managed from the same panel, providing a unified experience within the ecosystem.",
  "What benefits does using Ridery 360 have compared to the Ridery app?":
    "What benefits does using Ridery 360 have compared to the Ridery app?",
  "With Ridery 360, companies access tax invoicing, personalized 24/7 attention, budget control per user and real-time visibility of each trip or shipment. In addition, the panel is integrated with the Ridery app, which allows collaborators to have a self-manageable experience.":
    "With Ridery 360, companies access tax invoicing, personalized 24/7 attention, budget control per user and real-time visibility of each trip or shipment. In addition, the panel is integrated with the Ridery app, which allows collaborators to have a self-manageable experience.",
  "Join the +1,500 companies that trust us":
    "Join the +1,500 companies that trust us",
  "Start now without initial costs": "Your team moves. You stay in control.",
  "No previous recharges": "No upfront top-ups: Activate your account, set spending limits, review every transaction, and manage your billing from one place.",
  "Register and set up your account": "Activate your account",
  "Guarantee smooth expense management without paying additional service fees.":
    "Start operating with your agreed credit limit and no activation fees.",
  "Add your collaborators": "Your team operates",
  "Assign balance for trips or shipments and personalized spending limits.":
    "Assign each collaborator a spending limit or overdraft for trips and shipments.",
  "Manage your logistics with Ridery 24/7":
    "Manage your billing",
  "Manage mobility, deliveries, logistics and benefits of your business in one place.":
    "Receive your consolidated usage, manage your payments, and track withholdings from one place.",
  "Reduce your transport, shipping and logistics costs":
    "Reduce your transport, shipping and logistics costs",
  "up to 35%": "up to 35%",
  "with Ridery": "with Ridery",
  "Talk to us": "Talk to us",

  // ProspectModal translations
  "Welcome to Ridery's Corporate Panel": "Welcome to Ridery's Corporate Panel",
  "For us it is a pleasure to be your best mobility ally and take care of the comfort of your executives, ensuring that they will be there when you need them and that they will receive the most exclusive and safe transfer in Venezuela.":
    "For us it is a pleasure to be your best mobility ally and take care of the comfort of your executives, ensuring that they will be there when you need them and that they will receive the most exclusive and safe transfer in Venezuela.",
  "In order to help you, we need you to provide us with the following information so that our team can communicate with you.":
    "In order to help you, we need you to provide us with the following information so that our team can communicate with you.",
  "Basic contact information": "Basic contact information",
  "Business name": "Business name",
  "Contact phone": "Contact phone",
  "Rif type": "Rif type",
  "Rif number": "Rif number",
  Position: "Position",
  Next: "Next",
  "Tell us about your business": "Tell us about your business",
  "What is the size of the company in number of employees?":
    "What is the size of the company in number of employees?",
  "How many trips do you think your company would need on average per week?":
    "How many trips do you think your company would need on average per week?",
  "In which city is the population of employees you want to mobilize?":
    "In which city is the population of employees you want to mobilize?",
  "Other (input)": "Other (input)",
  "We would like to know a little about your specific need in order to serve you better. Please, explain to us what you expect from our corporate service":
    "We would like to know a little about your specific need in order to serve you better. Please, explain to us what you expect from our corporate service",
  "Sending Form": "Sending Form",
  "Thanks for your interest": "Thanks for your interest",
  "Our sales team will contact you": "Our sales team will contact you",
  "There has been a problem": "There has been a problem",
  "You can go back and retry": "You can go back and retry",
  "Go back to the start": "Go back to the start",

  // Testimonials
  "The platform has been key in optimizing our operations. It is intuitive, easy to use and gives us excellent information control. The team's attention has been impeccable, always willing to support us. Undoubtedly, a tool that has contributed to our growth.":
    "The platform has been key in optimizing our operations. It is intuitive, easy to use and gives us excellent information control. The team's attention has been impeccable, always willing to support us. Undoubtedly, a tool that has contributed to our growth.",
  "We value the efficiency and flexibility that Ridery has brought to our corporate mobility. The platform is intuitive and the transfers are safe and punctual. It has optimized our times and has directly contributed to the productivity of our teams. A service we recommend.":
    "We value the efficiency and flexibility that Ridery has brought to our corporate mobility. The platform is intuitive and the transfers are safe and punctual. It has optimized our times and has directly contributed to the productivity of our teams. A service we recommend.",
  "Ridery's service and attention have been excellent. From the beginning we have received constant support. We value their focus on innovation and building long-term relationships with their clients.":
    "Ridery's service and attention have been excellent. From the beginning we have received constant support. We value their focus on innovation and building long-term relationships with their clients.",
  "We are very satisfied with Ridery's service. The platform is practical, the vehicles and drivers meet the standards we are looking for, and the team's attention is first-class. It is a service we highly recommend.":
    "We are very satisfied with Ridery's service. The platform is practical, the vehicles and drivers meet the standards we are looking for, and the team's attention is first-class. It is a service we highly recommend.",
  "Ridery's service is one of our first options for national transfers. The platform is easy and friendly both for our collaborators and for the company. It facilitates the management and assignment of trips, and we hope to continue strengthening this alliance.":
    "Ridery's service is one of our first options for national transfers. The platform is easy and friendly both for our collaborators and for the company. It facilitates the management and assignment of trips, and we hope to continue strengthening this alliance.",
  "Mobility and transport": "Mobility and transport",
  "Integrated shipments": "Integrated shipments",

  "Promote your brand in advertising spaces in the Ridery app or mobile screens in our vehicles.":
    "Promote your brand in advertising spaces in the Ridery app or mobile screens in our vehicles.",
  "Logistics and heavy cargo.": "Logistics and heavy cargo.",
  "your business.2": "your business.",
  Explore: "Explore",
  "Enjoy the benefits of the ecosystem": "Enjoy the benefits of the ecosystem",

  "100% certified drivers and vehicles": "100% certified drivers and vehicles",
  "For the safety of your collaborators, all drivers go through a rigorous certification process:":
    "For the safety of your collaborators, all drivers go through a rigorous certification process:",
  "Comprehensive psychotechnical evaluation.":
    "Comprehensive psychotechnical evaluation.",
  "Mechanical and aesthetic review of the vehicle.":
    "Mechanical and aesthetic review of the vehicle.",
  "Verification of up-to-date legal documents.":
    "Verification of up-to-date legal documents.",

  "24/7 personalized support channel": "24/7 personalized support channel",
  "To guarantee an optimal experience, we provide accompaniment and comprehensive support at all times:":
    "To guarantee an optimal experience, we provide accompaniment and comprehensive support at all times:",
  "Immediate support for any incident or requirement.":
    "Immediate support for any incident or requirement.",
  "Assignment of a dedicated executive for inquiries and follow-up.":
    "Assignment of a dedicated executive for inquiries and follow-up.",
  "Real-time monitoring of trips and shipments.":
    "Real-time monitoring of trips and shipments.",

  "Full access to all our services": "Full access to all our services",
  "From mobility and logistics to advertising and employee well-being, the entire Ridery ecosystem is at your disposal:":
    "From mobility and logistics to advertising and employee well-being, the entire Ridery ecosystem is at your disposal:",
  "Centralized billing management.": "Centralized billing management.",
  "Hiring advertising spaces to boost your brand.":
    "Hiring advertising spaces to boost your brand.",
  "API integration to automate your logistics processes.":
    "API integration to automate your logistics processes.",

  "Frequently Asked Questions": "Frequently Asked Questions",
  "If you have any questions, here are some answers that may help you. If you need personalized support, don't hesitate to contact us.":
    "If you have any questions, here are some answers that may help you. If you need personalized support, don't hesitate to contact us.",
  "Go back": "Go back",
  "Error loading cities. Please try again later.":
    "Error loading cities. Please try again later.",
  "No data": "No data",
  "Create new trip": "Create new trip",
  Schedule: "Schedule",
  Recents: "Recents",
  Driver: "Driver",
  Map: "Map",
  "Add description": "Add description",
  "Copy trip link": "Copy trip link",
  "Copy shipment link": "Copy shipment link",
  Username: "Username",
  in_progress: "In progress",
  Completeds: "Completed",
  Schedules: "Schedule",
  Cancelleds: "Cancelled",
  Filters: "Filters",
  "Create new parcel": "Create new parcel",
  "No results found": "No results found",
  "Service note": "Service note",
  "Cancelled by provider": "Cancelled by provider",
  "cargo_logistics": "Cargo logistics",
  "cargoLogistics": "Cargo logistics",
  "quote_your_cargo_title": "Get a quote for your cargo transport with Ridery",
  "quote_your_cargo_subtitle": "Plan and quote your cargo transport quickly and safely",
  "cargo_logistics_origin_destination": "Enter the origin and destination of the shipment",
  "cargo_origin_label": "Origin address",
  "cargo_origin_placeholder": "e.g. Galpón Industrial Los Ruices, Caracas",
  "cargo_destination_label": "Destination address",
  "cargo_destination_placeholder": "e.g. Centro Empresarial La Trinidad, Caracas",
  "cargo_pick_your_truck": "Choose the right truck for your load",
  "cargo_truck_type_label": "Truck type",
  "cargo_truck_type_placeholder": "Select type",
  "cargo_truck_model_label": "Truck model",
  "cargo_truck_model_placeholder": "Select model",
  "cargo_truck_capacity_label": "Load capacity",
  "cargo_truck_capacity_placeholder": "Select capacity",
  "cargo_service_type_label": "Service type",
  "cargo_service_type_placeholder": "Select service type",
  "cargo_assistant_label": "Number of helpers",
  "cargo_assistant_placeholder": "Select number of helpers",
  "cargo_service_details": "Add the service details",
  "cargo_generate_quote_with_registered_data": "Generate quote with registered information",
  "cargo_enterprise_name_label": "Company name",
  "cargo_enterprise_email_label": "Email",
  "cargo_enterprise_phone_label": "Phone number",
  "cargo_add_company_information": "Enter the information of the person who will manage the quote",
  "cargo_find_truck_long": "Not sure which truck to choose? Find it here",
  "cargo_find_truck_short": "Not sure which truck to choose?",
  "cargo_request_quote_button": "Request quote",
  "cargo_service_options_title": "Answer a few quick questions so we can recommend the ideal truck for your load.",
  "cargo_service_transportation_way": "How is your load packed?",
  "cargo_service_options_service_type": "What type of service do you need?",
  "cargo_service_options_box": "In boxes",
  "cargo_service_options_pallets": "On pallets",
  "cargo_service_options_loose": "In bulk (loose)",
  "cargo_service_options_moveout": "Moving",
  "cargo_service_options_transport": "Transport of furniture or new products",
  "cargo_service_options_separator": "Or rather",
  "box_calculate_by_title": "How would you like to calculate your load?",
  "box_calculate_by_box_volume": "By volume",
  "box_calculate_by_box_weight": "By weight",
  "dimentions_title": "Enter the measurements of your boxes",
  "dimentions_subtitle": "Use the external dimensions of each box to calculate the total space.",
  "weight_title": "Enter the total weight of your boxes",
  "weight_subtitle": "If you know the weight per box, add up the estimated total.",
  "weight_label": "Total weight (kg)",
  "weight_placeholder": "",
  "dimentions_height_label": "Height (cm)",
  "dimentions_height_placeholder": "",
  "dimentions_width_label": "Width (cm)",
  "dimentions_width_placeholder": "",
  "dimentions_length_label": "Length (cm)",
  "dimentions_length_placeholder": "",
  "dimentions_boxes_label": "Number of boxes",
  "dimentions_boxes_placeholder": "",
  "dimentions_total_label": "Calculated cubic meters: ",
  "ideal_truck_title": "Based on your load, these are the ideal options",
  "ideal_truck_title_moveout": "For moves, this is the ideal option",
  "ideal_truck_subtitle": "You can continue to see the details and get a quote for your transport.",
  "ideal_truck_subtitle_moveout": "We suggest including 4 helpers for loading.",
  "pallets_title": "How many pallets do you need to transport?",
  "pallets_subtitle": "Choose the range that best suits your load.",
  "pallets_option_1": "1 pallet",
  "pallets_option_2_4": "2 - 4",
  "pallets_option_5_6": "5 - 6",
  "pallets_option_7_10": "7 - 10",
  "pallets_option_11_12": "11 - 12",
  "pallets_option_13_14": "13 - 14",
  "pallets_option_15_24": "15 - 24",
  "loose_title": "What type of load are you moving?",
  "loose_subtitle": "Select the option that best describes your load.",
  "loose_option_trash": "Trash or debris",
  "loose_option_sand": "Sand",
  "loose_option_pipes": "Pipes or rebar",
  "transport_title": "What type of items are you moving?",
  "transport_subtitle": "Choose the option that best describes what you need to move.",
  "transport_option_appliances": "Refrigerators / Washing machines",
  "transport_option_furniture": "Small furniture",
  "material_dimentions_title": "Indicate the measurements of your material",
  "material_dimentions_subtitle": "Enter the length and total weight to calculate the most suitable truck.",
  "material_dimentions_length_label": "Length (m)",
  "material_dimentions_length_placeholder": "",
  "material_dimentions_weight_label": "Total weight (kg)",
  "material_dimentions_weight_placeholder": "",
  "cargo_quote_request_sent": "Successful quote",
  "cargo_quote_request_body": "The estimated cost of your service is ",
  "cargo_quote_request_body_2": "Check the downloaded PDF or the email we sent for more details on the service.",
  "cargo_quote_support_time": "Business hours:\nMonday to Friday, from 9:00 AM to 5:00 PM",
  "cargo_service": "Service",
  "cargo_origin_address": "Origin address",
  "cargo_destination_address": "Destination address",
  "cargo_estimated_time": "Estimated time",
  "cargo_cancellation_fee": "Cancellation fee",
  "cargo_invoice_team": "Ridery Corporate team",
  "cargo_invoice_thanks": "Thank you for choosing us",
  "cargo_invoice_reference_note": "Note: This quote is a reference value for the service",
  "cargo_invoice_reference_note_2": "*the value of the service is subject to changes",
  "cargo_invoice_service": "Cargo service quote",
  "cargo_invoice_service_quote": "Service quote",
  "cargo_invoice_date": "Date issued",
  "cargo_invoice_service_for": "Service quote for",
  "cargo_error_initializing_form": "Error initializing form, try again later",
  "cargo_origin_error": "Error getting origin address, try again later",
  "cargo_destination_error": "Error getting destination address, try again later",
  "cargo_quote_error": "Error requesting quote, try again later",
  "cargo_addresses_require_map_selection": "Select origin and destination from the address suggestions so we can locate both points on the map.",
  "cargo_create_quote_error": "Error creating quote, try again later",
  "cargo_find_your_truck": "Find the right truck",
  "find_your_truck_next_step": "Next",
  "find_your_truck_previous_step": "back",
  "find_your_truck_restart": "Restart",
  "find_your_truck_end": "End",
  "ideal_truck_error": "Error getting ideal truck, try again later",
  "contact_us_modal_title": "We couldn't load the service",
  "contact_us_modal_content": "Please try again in a few minutes or contact your account executive for assistance with your request.",
  "contact_us_modal_go_home": "Back to Dashboards",
  "contact_us_modal_send_message": "Contact Executive",
  "validation.alpha_special": "The field {fieldName} only allows letters, numbers, spaces and the characters: . - _ @ ,",
  "contact_us_modal_message": "Hi 👋\nI had an issue loading the *Flety* service in *Ridery 360*.\n\nI'd like your help to get a *quote and continue with the request* from here.\nThank you!",
  "ideal_truck_contact_us_modal_message": "Hi 👋\nI had an issue finding an ideal truck for my load in *Flety* in *Ridery 360*.\n\nI'd like your help to get a *quote and continue with the request* from here.\nThank you!",
  "ideal_truck_no_trucks": "We couldn't find an ideal truck for your load. Please contact your account executive for assistance with your request.",

  // Rentals
  Rentals: "Rentals",
  Origin: "Origin",
  "Fleet type": "Fleet type",
  "Quote your Trip": "Quote your Trip",
  "Enter your trip details to get a personalized quote":
    "Enter your trip details to get a personalized quote.",
  "Enter your pickup location": "Enter your pickup location",
  "Enter your service's pickup location":
    "Enter your service's pickup location",
  "Pickup Location": "Pickup Location",
  "Select the date and time of your trip":
    "Select the date and time of your trip",
  rental_time_notice:
    "Remember to book your trip with a minimum of {hours} hours' notice and up to {days} days from today.",
  "Trip date": "Trip date",
  "DD/MM/YYYY": "MM/DD/YYYY",
  "Trip time": "Trip time",
  "How long do you need it for?": "How long do you need it for?",
  "Select the number of hours you need for your service":
    "Select the number of hours you need for your service",
  "Select number of hours": "Select number of hours",
  rental_outside_operational_area:
    "This address is outside of Ridery's operational area.",
  "Trip details": "Trip details",
  "Enter the details and select the fleet that best suits your needs":
    "Enter the details and select the fleet that best suits your needs",
  "Reason for your trip": "Reason for your trip",
  "Reason for your trip (Optional)": "Reason for your trip (Optional)",
  "Select a reason for your trip": "Select a reason for your trip",
  "Trip details (Optional)": "Trip details (Optional)",
  "Enter some details about your trip": "Enter some details about your trip",
  "Select a fleet": "Select a fleet",
  "Select the best fleet for your trip from our options":
    "Select the best fleet for your trip from our options",
  Passengers: "passengers",
  Suitcase: "suitcase",
  "This fleet is not available for the selected number of hours":
    "This fleet is not available for the selected number of hours",
  "No fleets available for the selected hours":
    "No fleets available for the selected hours",
  "Error loading trip reasons": "Error loading trip reasons",
  "Error loading fleets": "Error loading fleets",
  "Select fleet type coming soon": "Select fleet type coming soon",
  "This step is under development": "This step is under development",
  "Review and confirm your rental quote":
    "Review and confirm your rental quote",
  "Quote created successfully": "Quote created successfully",
  "Esta dirección se encuentra fuera del área operativa de Ridery.":
    "This address is outside of Ridery's operational area.",
  "This service is not available in the selected location":
    "This service is not available in the selected location",
  Other: "Other",
  Hours: "Hours",
  Resume: "Resume",
  Fleet: "Fleet",
  "Enter the details of your trip": "Enter the details of your trip",
  "Enter some details about your trip (optional)":
    "Enter some details about your trip (optional)",
  Duration: "Duration",
  "Trip description": "Trip description",
  "Create quote": "Create quote",
  "No description available": "No description available",
  "When you create a rental, you agree to our":
    "When you create a rental, you agree to our",
  "Terms and conditions": "Terms and conditions",
  "Privacy policies": "Privacy policies",
  "and the": "and the",
  "Download quote": "Download quote",
  "QUOTE ID": "Quote ID",
  "TRIP REASON": "Trip reason",
  "TRIP DETAILS": "Trip details",
  "Cotización de servicio": "Service quote",
  "Ready!": "Ready!",
  "Your quote is ready. If you want more information or prefer to confirm your trip, contact one of our agents.":
    "Your quote is ready. If you want more information or prefer to confirm your trip, contact one of our agents.",
  "This is only a quotation. Shortly, a Ridery agent will contact you to help you finalize your Rentals trip.":
    "This is only a quotation. Shortly, a Ridery agent will contact you to help you finalize your Rentals trip.",
  Important: "Important",
  "This service applies exclusively to transfers within the same city":
    "This service applies exclusively to transfers within the same city",
  "pay_corporate_bill": "Pay invoices",
  "dont_show_message_again": "Don't show this message again",
  "InvoicesToPay": "Invoices to pay",
  "invoices_to_pay_title": "Select invoices to pay",
  "invoices_to_pay_subtitle": "Select one or more invoices to pay them in a single transaction. If you have overdue invoices, you must include them. In the next step you will be able to manage withholdings.",
  "view_invoices": "View invoices",
  "available_credit": "Available credit",
  "credit_used": "Used",
  "available_amount": "Available amount",
  "available_credit_limit_tooltip": "Credit limit set together with your Sales Executive. To request any changes, please contact the person responsible.",
  "wallet_available_amount": "Available balance",
  "wallet_available_amount_tooltip": "Available balance in your corporate wallet.",
  "billing_status": "Billing status",
  "billing_status_info_tooltip":
    "Summary of upcoming, current, and overdue corporate invoice amounts.",
  "billing_status_upcoming": "Upcoming",
  "billing_status_current": "Active",
  "billing_status_overdue": "Overdue",
  "billing_footer_upcoming": "{days} days left",
  "billing_footer_expires": "Expires in {days} days",
  "billing_footer_overdue": "Expired {days} days ago",
  "billing_one_invoice": "1 invoice",
  "billing_n_invoices": "{n} invoices",
  "corporate_invoices_history": "Corporate invoices history",
  "bill_invoice_of_prefix": "Invoice for",
  "bill_invoice_all_panels": "all panels",
  "invoice_number": "Invoice number",
  "bill_status_all": "All",
  "bill_status_pending_payment": "Pending",
  "bill_status_processing_payment": "Processing Payment",
  "bill_status_partial_payment": "Partial Payment",
  "bill_status_paid": "Paid",
  "bill_status_cancelled": "Cancelled",
  "bill_status_reversed": "Reversed",
  "bill_status_annulled": "Annulled",
  "bill_status_overdue_plural": "Overdue",
  "bill_status_overdue": "Overdue",
  "bill_status_applied_credit_note": "Applied",
  "bill_status_processing_credit_note": "Processing",
  "bill_document_no": "Document No.",
  "bill_associated_panel": "Associated panel",
  "bill_type": "Type",
  "bill_period": "Period",
  "bill_period_to": "to",
  "bill_issue_date": "Issue date",
  "bill_due_date": "Due date",
  "bill_service_type": "Service type",
  "bill_amount": "Amount",
  "bill_amount_due": "Amount due",
  "bill_tooltip_amount_in_bs": "Amount in",
  "bill_tooltip_bcv_rate": "BCV rate",
  "bill_status": "Status",
  "bill_doc_type_invoice": "INV",
  "bill_doc_type_credit_note": "CN",
  "bill_service_type_transportation": "Transportation service",
  "bill_service_type_third_party": "Third-party account",
  "bill_payments_retentions_modal_title":
    "Payments and withholdings | Invoice #{number}",
  "bill_payment_details_total_amount": "Total amount",
  "bill_payment_details_includes_retentions": "Includes withholdings",
  "bill_payment_details_total_applied": "Total applied",
  "bill_payment_details_pending": "Pending",
  "bill_payment_in_review_hint": "under review",
  "bill_payment_in_review_tooltip":
    'This amount corresponds to payments with an "Under review" status',
  "bill_payment_pay": "Pay",
  "bill_payment_breakdown_title": "Payment breakdown",
  "bill_retentions_title": "Withholdings",
  "bill_payment_col_id": "Payment ID",
  "bill_payment_col_method": "Payment method",
  "bill_payment_col_amount": "Applied amount",
  "bill_payment_col_status": "Payment status",
  "bill_payment_auto": "Automatic",
  "bill_payment_manual": "Manual",
  "bill_retention_col_id": "Withholding ID",
  "bill_retention_col_type": "Type",
  "bill_retention_col_date": "Date",
  "bill_retention_col_percent": "Percentage",
  "bill_retention_col_amount": "Amount",
  "bill_retention_col_status": "Status",
  "bill_view": "View",
  "bill_payment_status_review": "Under review",
  "bill_payment_status_rejected": "Rejected",
  "bill_payment_status_confirmed": "Confirmed",
  "bill_payment_status_applied": "Applied",
  "bill_payment_status_saved": "Created",
  "bill_payment_status_skipped": "Review",
  "bill_retention_status_not_requested": "Not requested",
  "bill_retention_status_pending": "Pending",
  "bill_retention_status_approved": "Approved",
  "bill_retention_status_refused": "Rejected",
  "bill_retention_status_cancel": "Cancelled",
  "bill_payment_error_loading_invoice_details":
    "Could not load the invoice, please try again later",
  "date_from": "From",
  "date_to": "To",
  "date_range": "Date range",
  "bill_invoice_type": "Invoice type",
  "bill_invoice_type_automatic": "Automatic",
  "bill_invoice_type_cancellation": "Cancellation",
  "bill_actions": "Actions",
  "bill_discard_invoice": "Discard invoice",
  "bill_discard_invoice_confirm_title": "Discard this invoice?",
  "bill_discard_invoice_confirm_detail":
    "It will be removed from this list. Continue only if you intend to discard it.",
  "bill_invoice_selected_singular": "invoice selected",
  "bill_invoice_selected_plural": "invoices selected",
  "bill_continue_to_retentions": "Continue to retentions",
  "bill_billing_mismatch_title":
    "We couldn't group these invoices into a single payment.",
  "bill_billing_mismatch_body":
    "The invoices you selected belong to {childPanels} with different {billingData}, and to pay them together they all need to match. Review your selection or talk to your account manager to update the details.",
  "bill_billing_mismatch_child_panels": "child panels",
  "bill_billing_mismatch_billing_data": "billing information",
  "bill_review_invoices": "Review invoices",
  "bill_select_all_expired_invoices":
    "To include current invoices in the payment, you must select all overdue invoices.",
  "bill_islr_page_title": "ISLR withholding",
  "bill_islr_transport_title": "Transportation services",
  "bill_islr_transport_info_tooltip":
    "Withholdings for transportation services are applied automatically at 3% according to current regulations.",
  "bill_islr_transport_description":
    "Withholdings for transportation services are applied automatically at 3% according to current regulations. Upload your withholding vouchers to continue.",
  "bill_islr_third_party_title": "Third-party account services",
  "bill_islr_third_party_info_tooltip":
    "You can enable withholding and set the applicable percentage for your case.",
  "bill_islr_third_party_description":
    "If you need to apply withholding, enable it and choose the corresponding percentage. To continue with payment, uploading the vouchers is mandatory.",
  "bill_islr_retention_switch": "Withholding",
  "bill_islr_col_invoice_no": "Invoice no.",
  "bill_islr_col_retention_percent": "% Withholding",
  "bill_islr_col_retention_amount_bs": "Withholding amount in Bs.",
  "bill_islr_col_retention_amount_usd": "Withholding amount in USD",
  "bill_islr_col_voucher": "Voucher",
  "bill_islr_retention_amount_bs_tooltip": "Withholding amount in bolivars.",
  "bill_islr_retention_amount_usd_tooltip": "Withholding amount in US dollars.",
  "bill_islr_upload": "Upload",
  "bill_upload_retention_modal_title": "Associate withholding",
  "bill_upload_retention_file_label": "Withholding",
  "bill_upload_retention_save": "Save",
  "bill_upload_retention_success": "Withholding associated successfully",
  "bill_upload_retention_error": "Error uploading the withholding",
  "bill_payment_status_update_alert_title":
    "We're updating your payment status",
  "bill_payment_status_update_alert_body":
    "Some invoices may not yet appear as paid in your history. If that's your case, {highlight} and restore your available credit shortly. Thank you for your understanding.",
  "bill_payment_status_update_alert_body_highlight":
    "our team is already working to reconcile the payments",
  "bill_error_loading_invoices": "Error loading invoices",
  "bill_export_invoices_success": "Invoices exported successfully",
  "bill_export_invoices_error": "Error exporting invoices. Please try again later.",
  "bill_export_trips_success": "Trips exported successfully",
  "bill_export_trips_error": "Error exporting trips. Please try again later.",
  "bill_invoice_trips_details_title": "Trips and shipments details",
  "bill_invoice_label": "Invoice",
  "bill_islr_upload_retention_error": "Error uploading withholdings. Please try again.",
  "bill_islr_form_init_error":
    "Error initializing the form. Please try again later.",
  "bill_islr_remove_expired_invoice_error":
    "Only invoices that are not overdue can be removed.",
  "bill_islr_payment_summary_title": "Payment summary",
  "bill_islr_summary_transport_invoices": "Invoices for transportation service",
  "bill_islr_summary_retention": "Withholding",
  "bill_islr_summary_third_party_invoices": "Third-party account invoices",
  "bill_islr_summary_total_invoices": "Total invoices",
  "bill_islr_summary_total_retentions": "Total withholdings",
  "bill_islr_summary_total_to_pay": "Total to pay",
  "bill_islr_summary_includes_retentions": "(Includes withholdings)",
  "bill_islr_continue_to_payment": "Continue to payment",
  "bill_islr_upload_all_vouchers_notice":
    "You must upload all withholding vouchers before selecting the payment method.",
  "bill_action_view_invoice": "View invoice",
  "bill_action_view_trip_details": "View trip details",
  "bill_action_pay_invoice": "Pay invoice",
  "bill_action_view_payment_details": "View payments and withholdings",
  "bill_action_view_details": "View details",
  "bill_action_view_credit_note": "View credit note",
  "credit_note_title": "Credit note",
  "credit_note_issue_date": "Issue date",
  "credit_note_origin_invoice": "Origin invoice no.",
  "credit_note_status": "Status",
  "credit_note_amount": "Amount",
  "credit_note_description": "Description",
  "credit_note_application_title": "Credit note application",
  "credit_note_invoice_number": "Invoice no.",
  "credit_note_date": "Date",
  "credit_note_status_applied": "Applied",
  "credit_note_accept": "Accept",
  "dashboard_credit_blocked_tooltip":
    "To continue using the service, please review your credit limit with the appropriate contact or pay your overdue invoices",
  "monthly_metrics": "Monthly metrics",

  // Change expired password view
  ChangeExpiredPassword: "Change password",
  "Your password has expired": "Your password has expired",
  "For security reasons you must set a new password before continuing":
    "For security reasons you must set a new password before continuing.",
  "Current password": "Current password",
  "New password": "New password",
  "Password changed successfully": "Password changed successfully. Please sign in again.",
  "Action not available in assist mode": "This action is not available in assist mode",
  // Password policy checklist
  "At least 6 characters": "At least 6 characters",
  "At least one uppercase letter": "At least one uppercase letter",
  "At least one lowercase letter": "At least one lowercase letter",
  "At least one number": "At least one number",
  "At least one symbol": "At least one symbol (e.g. @, #, !, $)",
  "Password requirements": "Password requirements",

  invoice_assistance_pill: "Billing update",
  invoice_assistance_title_highlight: "This week ",
  invoice_assistance_title_rest: "we will not issue invoices",
  invoice_assistance_step_pause_title: "This week",
  invoice_assistance_step_pause_desc:
    "We are pausing billing while we make adjustments.",
  invoice_assistance_step_resume_title: "Monday the 9th",
  invoice_assistance_step_resume_desc:
    "We resume billing and generate your invoices with all trips completed.",
  invoice_assistance_benefit_prefix: "All your trips during these days ",
  invoice_assistance_benefit_highlight: "remain registered",
  invoice_assistance_benefit_suffix:
    " and will be included in your invoices on Monday, November 9.",

  proforma_assistance_pill: "New billing model",
  proforma_assistance_title_prefix: "Starting ",
  proforma_assistance_title_date: "Monday, November 9",
  proforma_assistance_title_suffix: ", you'll receive a proforma first",
  proforma_assistance_step_proforma_title: "Proforma",
  proforma_assistance_step_proforma_desc:
    "We send you the amount for the period's trips, in USD.",
  proforma_assistance_step_payment_title: "Payment",
  proforma_assistance_step_payment_desc:
    "You pay the proforma total from your panel.",
  proforma_assistance_step_invoice_title: "Invoice",
  proforma_assistance_step_invoice_desc:
    "We issue your tax invoice at the BCV rate on the payment date.",
  proforma_assistance_benefit_prefix: "This way your invoice reflects ",
  proforma_assistance_benefit_highlight: "exactly what you paid",
  proforma_assistance_benefit_suffix:
    ", with no exchange-rate differences.",
  proforma_assistance_note:
    "You can upload your withholding receipts once the invoice is issued.",
  proforma_assistance_footer_question:
    "Still have questions or want more information?",
  proforma_assistance_contact: "Contact me",
  proforma_assistance_understood: "Got it",
  proforma_assistance_contact_success_intro:
    "We have recorded your assistance request.",
  proforma_assistance_contact_success: "We will contact you shortly",
  proforma_assistance_error: "We couldn't save your response. Please try again.",
  proforma_assistance_auto_require_invalid: "Invalid request",
  proforma_assistance_auto_require_error:
    "Error registering your request, please try again later",
};
